import { z } from "zod";
import { ShortText, MediumText, idString } from "./common.js";
const ControlPlanRow = z
    .object({
    id: idString,
    item: ShortText,
    cadence: ShortText,
    responsible: ShortText,
    /** The tenant member `responsible` names, when picked from the people picker. */
    responsibleUserId: z.string().uuid().nullable().optional(),
    trigger: MediumText,
})
    .strict();
/**
 * Control Plan — Ensure, singleton. Sustained-monitoring table:
 * what we monitor (item), how often (cadence), who owns it (responsible),
 * and the trigger condition that prompts action.
 */
export const ControlPlanParamsSchema = z
    .object({
    rows: z.array(ControlPlanRow).max(50),
})
    .strict();
export const defaultControlPlanParams = {
    rows: [],
};
//# sourceMappingURL=controlPlan.js.map